import React from "react";
import { Row, Col } from "react-bootstrap";
import Avatar from "components/common/Avatar";

const UserInfoSection = ({ user, contactInfo, passportPhoto }) => (
  <>
    <h6 className="fw-bold">Applicant Information</h6>
    <div className="mt-3 d-flex gap-3 flex-wrap">
      <div style={{ height: 190 }}>
        {passportPhoto ? (
          <Avatar
            rounded="square"
            src={passportPhoto}
            size="5xl"
            className="h-100 cover rounded-4 overflow-hidden shadow-lg"
          />
        ) : (
          <Avatar
            rounded="square"
            size="4xl"
            name={user?.fullName}
            className="h-100 cover rounded-4 overflow-hidden shadow-lg"
          />
        )}
      </div>

      <div>
        <div className="mb-2">
          <label className="form-label text-xxs mb-0">Full Name</label>
          <h6 className="mb-0 fw-semibold text-sm">{user?.fullName}</h6>
        </div>
        <div className="mb-2">
          <label className="form-label text-xxs mb-0">Email</label>
          <h6 className="mb-0 fw-semibold text-sm">{user?.email}</h6>
        </div>
        <div className="mb-2">
          <label className="form-label text-xxs mb-0">Phone</label>
          <h6 className="mb-0 fw-semibold text-sm">{user?.phone}</h6>
        </div>
        <div className="mb-2">
          <label className="form-label text-xxs mb-0">Gender</label>
          <h6 className="mb-0 fw-semibold text-sm">
            {user?.gender || "Not provided"}
          </h6>
        </div>
      </div>
    </div>

    <Row className="mt-3">
      <Col>
        <h6 className="fw-bold">Contact Info</h6>
        <div className="mb-2">
          <label className="form-label text-xxs mb-0">Name</label>
          <h6 className="mb-0 fw-semibold text-sm">
            {contactInfo?.name || "Not provided"}
          </h6>
        </div>
        <div className="mb-2">
          <label className="form-label text-xxs mb-0">Email</label>
          <h6 className="mb-0 fw-semibold text-sm">
            {contactInfo?.email || "Not provided"}
          </h6>
        </div>
        <div className="mb-2">
          <label className="form-label text-xxs mb-0">Phone</label>
          <h6 className="mb-0 fw-semibold text-sm">
            {user?.phone || "Not provided"}
          </h6>
        </div>
      </Col>
    </Row>
  </>
);

export default UserInfoSection;
